//get the Gateway
require("gateway.js");

//for webinar notifications
require("./generic-promo-banner.js");

// Homepage scripts
require("./home-page");

//adding spin.js which might be a global dependancy.
import {Spinner} from 'spin.js';
window.Spinner = Spinner;

//spinner - based on spin.js -- does not seem to be working!
require("./spinner.js");

//This was in the original US bundle -- not sure what it does though.
require("./personalized-content.js");

// To remove widows.
require("./widont");

// Video Player.
require("./video-player");

// Miscellaneous code.
require("./lazy-loader");

//sticky premium content form
require("./sticky-gated-content/sticky-premium-form");

//Personalised topic forms for content recommendations.
//require("./personalised-topic-forms/personalised-topic-forms") // US script, conflicting with related media ts

// Other components.
require("./components");

// Other components.
require("./forms-and-subscriptions");

// AHP, Menu, Masthead and footer related code.
require("./menu-masthead-footer");

// To convert EPi dropdowns to custom dropdowns.
require("./custom-dropdown");

// To drive search functionality.
require("./search");

// Education page scripts
require("./education");

//export jQuery for outside use.
window.$ = $;

//insights scripts
require("./insights-components");

//Bind ToolTip
require("./bind-tool-tip");

//Select country automatically based on current URL.
require("./cta-country-dropdown-autoselect");

//legacy video pop-up
require("./legacy-video-popup.js");

//hero video player
require("./hero-video.js");

//find-an-etf
require("./find-an-etf.js");

//marketo-scripts
require("./marketo-script.js");

//responsive-banner
require("./background-images.js");

//exit trigger popup
require("./exit-trigger.js");

window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('.with-transparent-header')) {
      import('./header-override.js');
  }
  if (document.querySelector("#newsletter-modal .customized-newsletter")) {
      import('./newsletter-modal.js');
  }
});

// Temp redirect modal - listener for fund page menu items
import { checkAvailableLangVersion } from "./temp-redirect-modal";
document.addEventListener("dynamicMenuLoaded", () => {
    document.querySelectorAll(".fund-link").forEach(element => {
        element.addEventListener("click", (e) => {
            e.preventDefault();

            let url = element.getAttribute('href');

            checkAvailableLangVersion(url);
        })
    });
});
